import { MdLaunch, MdCode } from "react-icons/md";
import ragChatbot from "../assets/rag.png";
import gpt from "../assets/gpt.png";
import stock from "../assets/stock.png";
import movie from "../assets/movie.png";
import youtube from "../assets/EndToEndData.png";
import devSecOps from "../assets/devSecOps.png";

const PROJECTS = [
  {
    id: 1,
    src: ragChatbot,
    url: "https://gemini-rag-api.vercel.app/home",
    code: "https://github.com/berhane02/Gemini-rag-api",
    desc: "Next.js RAG application connecting Google Gemini LLM with external knowledge sources using Auth0 authentication, TypeScript, and real-time data integration",
    title: "Gemini Agentic assistant"
  },
  {
    id: 2,
    src: gpt,
    url: "https://ai-image-gene-saas.vercel.app/",
    code: "https://github.com/berhane02/ai-image-gene-saas",
    desc: "Full-stack generative AI SaaS web app using React, Clerk, Stripe, Express, Next.js, MySQL Prisma, OpenAI and Replicate API",
    title: "AI Agentic SaaS"
  },
  {
    id: 3,
    src: devSecOps,
    url: "https://github.com/berhane02/terraform-devsecops",
    code: "https://github.com/berhane02/terraform-devsecops",
    desc: "Build DevSecOps pipeline in order to understand behavior of bugs and vulnerabilities, like memory leak, deadlock, JVM crash, SQL injection and so on",
    title: "DevSecOps Pipeline"
  },
  {
    id: 4,
    src: movie,
    url: "https://front-media.vercel.app/",
    code: "https://github.com/berhane02/front-media",
    desc: "Full-stack movie review web app using React, JavaScript, HTML, CSS front-end and Spring Boot with MongoDB backend",
    title: "Movie Review App"
  },
  {
    id: 5,
    src: youtube,
    url: "https://github.com/berhane02/Data-Engineering/tree/main/EndToEndYoutubeDataAnalysis",
    code: "https://github.com/berhane02/Data-Engineering/tree/main/EndToEndYoutubeDataAnalysis",
    desc: "End-to-end YouTube data analysis using AWS cloud services S3, PySpark, Glue, Lambda, AWS Athena and QuickSight",
    title: "YouTube Data Analysis"
  },
  {
    id: 6,
    src: stock,
    url: "https://stockpredictionwebapp-prophet.streamlit.app/",
    code: "https://github.com/berhane02/StockPredictionWebApp",
    desc: "Built stock price prediction data app using Facebook's Prophet forecasting model, Yahoo Finance API and Plotly to display analysis",
    title: "Stock Prediction App"
  },
];

const Portfolio = () => {
  return (
    <div
      name="project"
      className="bg-[#080d14] w-full text-white"
    >
      <div className="max-w-screen-lg mx-auto px-6 md:px-8 py-6 md:py-8 lg:py-10">
        {/* Header */}
        <div className="mb-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-1 w-12 bg-blue-500"></div>
            <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight">
              Projects
            </h3>
          </div>
          <p className="text-gray-300 text-sm md:text-base lg:text-lg font-normal">
            Check out some of my work right here
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-5 md:gap-6">
          {PROJECTS.map(({ id, src, url, code, desc, title }) => (
            <div
              key={id}
              className="group bg-gray-900/40 rounded-lg overflow-hidden border border-gray-700/40 hover:border-blue-500/50 transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/20 backdrop-blur-sm flex flex-col h-full"
            >
              {/* Image Container */}
              <div className="relative overflow-hidden bg-gray-950/80">
                <img
                  src={src}
                  alt={title}
                  className="w-full h-32 xs:h-36 sm:h-40 md:h-44 object-cover transition-transform duration-500 group-hover:scale-110"
                />
                {/* Overlay on Hover */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                  <div className="p-3 w-full">
                    <h4 className="text-white font-bold text-base mb-1">
                      {title}
                    </h4>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-4 flex flex-col flex-grow">
                <h4 className="text-base md:text-lg font-bold text-white mb-2 group-hover:text-blue-400 transition-colors tracking-tight">
                  {title}
                </h4>
                <p className="text-gray-200 text-xs md:text-sm leading-relaxed mb-4 line-clamp-2 font-normal flex-grow">
                  {desc}
                </p>

                {/* Buttons */}
                <div className="flex gap-1.5 sm:gap-2 mt-auto">
                  <a
                    href={url}
                    target="_blank"
                    rel="noreferrer"
                    className="flex-1 min-w-0"
                  >
                    <button className="w-full flex items-center justify-center gap-1 sm:gap-1.5 px-2 sm:px-3 py-1.5 sm:py-2 bg-blue-600 hover:bg-blue-700 rounded-md sm:rounded-lg text-white text-[10px] xs:text-xs sm:text-xs font-medium transition-all duration-300 hover:scale-105 active:scale-95">
                      <MdLaunch className="flex-shrink-0" size={12} />
                      <span className="truncate">Demo</span>
                    </button>
                  </a>
                  <a
                    href={code}
                    target="_blank"
                    rel="noreferrer"
                    className="flex-1 min-w-0"
                  >
                    <button className="w-full flex items-center justify-center gap-1 sm:gap-1.5 px-2 sm:px-3 py-1.5 sm:py-2 bg-gray-700 hover:bg-gray-600 rounded-md sm:rounded-lg text-white text-[10px] xs:text-xs sm:text-xs font-medium transition-all duration-300 hover:scale-105 active:scale-95">
                      <MdCode className="flex-shrink-0" size={12} />
                      <span className="truncate">Code</span>
                    </button>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>


    </div>
  );
};

export default Portfolio;
